import { useCallback, useState } from 'react';
import { getBaseZ } from '../utils/canvasUtils';

// Хук для управления Z-order элементов
export const useZOrder = () => {
    const [zCounter, setZCounter] = useState(0);

    const assignZ = useCallback((el) => ({
        ...el,
        z: getBaseZ(el) + zCounter + 1 + Math.random() / 1000
    }), [zCounter]);

    const ensureZ = useCallback((els) => {
        let nextZ = zCounter;

        return els.map((el) => {
            if (el.z != null) {
                nextZ = Math.max(nextZ, el.z);
                return el;
            }

            nextZ += 1;
            return {
                ...el,
                z: nextZ + Math.random() / 1000
            };
        });
    }, [zCounter]);

    const syncZCounter = useCallback((els) => {
        const maxZ = Math.max(0, ...els.map((el) => el.z || 0));
        setZCounter((prev) => (maxZ > prev ? maxZ : prev));
    }, []);

    const incrementZCounter = useCallback(() => setZCounter((z) => z + 1), []);

    return {
        zCounter,
        assignZ,
        ensureZ,
        syncZCounter,
        incrementZCounter,
        setZCounter
    };
};
